import React from 'react';
import { useBackgroundJobs } from '../context/BackgroundJobsContext';

const BackgroundJobsProgress = () => {
  const { encodingJobs, deletionJobs } = useBackgroundJobs();
  const hasAny = encodingJobs.length > 0 || deletionJobs.length > 0;
  if (!hasAny) return null;

  return (
    <div
      className="fixed bottom-4 right-4 z-[9999] flex flex-col gap-2 w-72 max-w-[calc(100vw-2rem)]"
      aria-live="polite"
      aria-label="Background jobs progress"
    >
      {encodingJobs.map((job) => (
        <div
          key={job.id}
          className="bg-white rounded-lg shadow-lg border border-gray-200 p-3"
        >
          <div className="flex items-center gap-2 mb-1.5">
            <div className="animate-spin rounded-full h-4 w-4 border-2 border-blue-500 border-t-transparent flex-shrink-0" />
            <span className="text-sm font-medium text-gray-800 truncate">
              Encoding: {job.label}
            </span>
          </div>
          <div className="flex items-center justify-between text-xs text-gray-600 mb-1">
            <span>Photos</span>
            <span className="font-semibold">
              {job.current} / {job.total}
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
            <div
              className="bg-blue-500 h-2 rounded-full transition-all duration-300"
              style={{
                width: `${job.total > 0 ? Math.min(100, (job.current / job.total) * 100) : 0}%`,
              }}
            />
          </div>
        </div>
      ))}
      {deletionJobs.map((job) => (
        <div
          key={job.id}
          className="bg-white rounded-lg shadow-lg border border-gray-200 p-3"
        >
          <div className="flex items-center gap-2 mb-1.5">
            <div className="animate-spin rounded-full h-4 w-4 border-2 border-amber-500 border-t-transparent flex-shrink-0" />
            <span className="text-sm font-medium text-gray-800 truncate">
              Deleting: {job.label}
            </span>
          </div>
          <div className="flex items-center justify-between text-xs text-gray-600 mb-1">
            <span>Photos</span>
            <span className="font-semibold">{job.total != null ? job.total : '—'}</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
            <div
              className="bg-amber-500 h-2 rounded-full animate-pulse"
              style={{ width: '100%' }}
              aria-hidden
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default BackgroundJobsProgress;
